import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import { useTranslations } from '@/composables/useTranslations';

/**
 * Central image upload cap from the server (min of IMAGE_UPLOAD_MAX_MB, upload_max_filesize, post_max_size).
 */
export function useImageUploadLimit() {
    const { t } = useTranslations();
    const maxMb = computed(() => {
        const v = usePage().props.imageUploadMaxMb;

        if (typeof v === 'number' && !Number.isNaN(v)) {
            return v;
        }

        if (typeof v === 'string' && v !== '') {
            const n = Number(v);

            return Number.isNaN(n) ? 25 : n;
        }

        return 25;
    });

    function lineWithMax(prefix: string): string {
        return `${prefix} · ${t('tools.dropzone.upload_limit_max', 'max')} ${maxMb.value} MB`;
    }

    function lineUpTo(prefix: string): string {
        return `${prefix} · ${t('tools.dropzone.upload_limit_up_to', 'up to')} ${maxMb.value} MB`;
    }

    return { maxMb, lineWithMax, lineUpTo };
}
